<template>
  <main>
    <div v-html="pageCate.info.content">
    </div>
  </main>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "sourceP",
  data() {
    return {};
  },
  computed:mapGetters(['pageCate'])
};
</script>

<style lang='less' scoped>
</style>


// WEBPACK FOOTER //
// src/components/product/sourceP.vue